import { MercerSurveyType } from '@coin/shared/core/util-enums';
import { CustomerSurvey } from './customer-survey-data.model';
import { MercerCareerStream } from './mercer-career-stream.enum';

export const MERCER_DEFAULT_SURVEY: CustomerSurvey = {
  id: 'df0f6a93-5b50-4efb-a3a4-646d2295eed0',
  surveyType: MercerSurveyType.Default,
  questions: [
    {
      id: '33211424-93dd-41c9-87de-f7dac11c2de3',
      isActive: true,
      treeLevel: 0,
      title: 'survey.mercer.q1-question',
      answers: [
        {
          id: '7d121867-7872-460b-a2e5-802ae56ba994',
          title: 'survey.mercer.q1-answer-a-title',
          linkedSurveyQuestionId: '3354a57f-0f41-4a1d-a445-7a7040f0bcc1',
          description: 'survey.mercer.q1-answer-a-sub-title'
        },
        {
          id: '824b2451-8889-47b7-b2bc-c1ec9ebbf73c',
          title: 'survey.mercer.q1-answer-b-title',
          linkedSurveyQuestionId: '64cde6f1-2302-41be-b571-ac37fe732fe3',
          description: 'survey.mercer.q1-answer-b-sub-title'
        },
        {
          id: '9e386c67-a0c6-48c5-9e24-c7b10b099626',
          title: 'survey.mercer.q1-answer-c-title',
          linkedSurveyQuestionId: '3c810f4c-b8cc-4424-af2e-53aac85e827a',
          description: 'survey.mercer.q1-answer-c-sub-title'
        },
        {
          id: '393086fa-3219-40af-8ac2-90c7fcdf12d7',
          title: 'survey.mercer.q1-answer-d-title',
          linkedSurveyQuestionId: 'd251eb4a-6684-4cb5-95e2-b7e0aeffd16d',
          description: 'survey.mercer.q1-answer-d-sub-title'
        }
      ]
    },
    {
      id: '3354a57f-0f41-4a1d-a445-7a7040f0bcc1',
      title: 'survey.mercer.q2-question',
      treeLevel: 1,
      answers: [
        {
          id: 'bdf23ef1-3e83-450a-96fc-4144235eee23',
          linkedSurveyQuestionId: 'ae6e147b-a0c1-4ae6-8323-8b3fcfcdd4a5',
          title: 'survey.mercer.q2-answer-a-title',
          description: 'survey.mercer.q2-answer-a-sub-title'
        },
        {
          id: '32a5546a-5723-4b7b-8124-6f186390eb80',
          linkedSurveyQuestionId: '8ddac64e-e80e-445c-81d4-6367be890fee',
          title: 'survey.mercer.q2-answer-b-title',
          description: 'survey.mercer.q2-answer-b-sub-title'
        },
        {
          id: '1dbdcd5b-541f-4faa-826f-1a057c50600b',
          linkedSurveyQuestionId: 'cfd3648d-c103-4a9e-b7ad-823c0c27b9c7',
          title: 'survey.mercer.q2-answer-c-title',
          description: 'survey.mercer.q2-answer-c-sub-title'
        }
      ]
    },
    {
      id: 'ae6e147b-a0c1-4ae6-8323-8b3fcfcdd4a5',
      title: 'survey.mercer.q21-question',
      treeLevel: 2,
      answers: [
        {
          id: 'f7762295-a2aa-41b6-a888-33cea137da96',
          linkedSurveyResultId: '6d5a9229-0dcf-4b61-8de2-fbc0b1d16dbe',
          title: 'survey.mercer.q21-answer-a-title',
          description: 'survey.mercer.q21-answer-a-sub-title'
        },
        {
          id: 'a2d04dea-6e62-42ad-9861-62b13e6b620d',
          linkedSurveyResultId: '6d5a9229-0dcf-4b61-8de2-fbc0b1d16dbe',
          title: 'survey.mercer.q21-answer-b-title',
          description: 'survey.mercer.q21-answer-b-sub-title'
        },
        {
          id: 'd98e9490-1b21-4a06-990c-b8d47dbd135f',
          linkedSurveyResultId: 'e7e26f54-d5d2-4e63-96bf-46ea24bfa8e1',
          title: 'survey.mercer.q21-answer-c-title',
          description: 'survey.mercer.q21-answer-c-sub-title'
        },
        {
          id: 'a286b68c-0759-4f21-a8cc-91ecca8880cd',
          linkedSurveyResultId: '522b3c4f-b312-47b9-b573-340521ddb34f',
          title: 'survey.mercer.q21-answer-d-title',
          description: 'survey.mercer.q21-answer-d-sub-title'
        },
        {
          id: 'f7b409b3-2e57-48b7-95d0-aa41e59e4286',
          linkedSurveyQuestionId: '58e9e6c0-0b51-4710-af2b-6d9dcaff9635',
          title: 'survey.mercer.q21-answer-e-title',
          description: 'survey.mercer.q21-answer-e-sub-title'
        }
      ]
    },
    {
      id: '8ddac64e-e80e-445c-81d4-6367be890fee',
      title: 'survey.mercer.q22-question',
      treeLevel: 2,
      answers: [
        {
          id: '3631b39a-ecb7-42c2-8b57-34ad161348db',
          linkedSurveyQuestionId: '9788a4af-8da1-411d-8f86-daefcf94e5ae',
          title: 'survey.mercer.q22-answer-a-title',
          description: 'survey.mercer.q22-answer-a-sub-title'
        },
        {
          id: 'e03cf0e9-3672-43c3-b6c1-3b0f471d9b89',
          linkedSurveyQuestionId: '88abbdb2-5796-464d-8aad-2a3afdc5d4c0',
          title: 'survey.mercer.q22-answer-b-title',
          description: 'survey.mercer.q22-answer-b-sub-title'
        }
      ]
    },
    {
      id: 'cfd3648d-c103-4a9e-b7ad-823c0c27b9c7',
      title: 'survey.mercer.q23-question',
      treeLevel: 2,
      answers: [
        {
          id: 'a08b5e51-a59f-4df0-b4d3-95810783ea45',
          linkedSurveyResultId: 'e7e26f54-d5d2-4e63-96bf-46ea24bfa8e1',
          title: 'survey.mercer.q23-answer-a-title',
          description: 'survey.mercer.q23-answer-a-sub-title'
        },
        {
          id: 'bab64fbd-79c8-42ab-b271-46dc23241083',
          linkedSurveyResultId: '522b3c4f-b312-47b9-b573-340521ddb34f',
          title: 'survey.mercer.q23-answer-b-title',
          description: 'survey.mercer.q23-answer-b-sub-title'
        },
        {
          id: '8deefbbf-bf6f-4326-9cd3-9f9ddf6aacc3',
          linkedSurveyResultId: '77aa62e6-61f3-4e81-bdbe-0dd222449221',
          title: 'survey.mercer.q23-answer-c-title',
          description: 'survey.mercer.q23-answer-c-sub-title'
        },
        {
          id: '47a8cbdd-bfef-42ad-b6fe-860797b01673',
          linkedSurveyResultId: '602ced90-2f74-493c-af4f-f99e2323ec2b',
          title: 'survey.mercer.q23-answer-d-title',
          description: 'survey.mercer.q23-answer-d-sub-title'
        }
      ]
    },
    {
      id: '58e9e6c0-0b51-4710-af2b-6d9dcaff9635',
      title: 'survey.mercer.q211-question',
      treeLevel: 3,
      answers: [
        {
          id: '8e35de6f-bc1e-498c-aeef-810e4c4a0a66',
          linkedSurveyResultId: '77aa62e6-61f3-4e81-bdbe-0dd222449221',
          title: 'survey.mercer.q211-answer-a-title',
          description: 'survey.mercer.q211-answer-a-sub-title'
        },
        {
          id: '65081bba-c89b-4236-ac7a-7f4833aa462b',
          linkedSurveyResultId: '75aa52e6-61f3-4e81-bdbe-0dd473449221',
          title: 'survey.mercer.q211-answer-b-title',
          description: 'survey.mercer.q211-answer-b-sub-title'
        }
      ]
    },
    {
      id: '9788a4af-8da1-411d-8f86-daefcf94e5ae',
      title: 'survey.mercer.q221-question',
      treeLevel: 3,
      answers: [
        {
          id: 'a2be4e63-08dc-4a86-9317-7e932c301c8d',
          linkedSurveyResultId: '6d5a9229-0dcf-4b61-8de2-fbc0b1d16dbe',
          title: 'survey.mercer.q221-answer-a-title'
        },
        {
          id: '13fe3fb9-c42a-43fb-a227-9ba6289deb93',
          linkedSurveyResultId: 'e7e26f54-d5d2-4e63-96bf-46ea24bfa8e1',
          title: 'survey.mercer.q221-answer-b-title'
        }
      ]
    },
    {
      id: '88abbdb2-5796-464d-8aad-2a3afdc5d4c0',
      title: 'survey.mercer.q222-question',
      treeLevel: 3,
      answers: [
        {
          id: 'b9a9c66f-bbf9-4602-b798-c799e0088515',
          linkedSurveyResultId: 'e7e26f54-d5d2-4e63-96bf-46ea24bfa8e1',
          title: 'survey.mercer.q222-answer-a-title'
        },
        {
          id: 'ce53b37a-640e-42e1-b600-6196d583f153',
          linkedSurveyResultId: '522b3c4f-b312-47b9-b573-340521ddb34f',
          title: 'survey.mercer.q222-answer-b-title'
        }
      ]
    },
    {
      id: '64cde6f1-2302-41be-b571-ac37fe732fe3',
      title: 'survey.mercer.q3-question',
      treeLevel: 1,
      answers: [
        {
          id: '42b4856d-8533-4c44-8c2b-392eba0ab676',
          linkedSurveyQuestionId: 'd5859ca2-d0de-4310-a808-1062173a05c9',
          title: 'survey.mercer.q3-answer-a-title',
          description: 'survey.mercer.q3-answer-a-sub-title'
        },
        {
          id: '6cd6f7f6-afea-47e3-92d0-4c0e352fa8b2',
          linkedSurveyResultId: '602ced90-2f74-493c-af4f-f99e2323ec2b',
          title: 'survey.mercer.q3-answer-b-title',
          description: 'survey.mercer.q3-answer-b-sub-title'
        },
        {
          id: 'a2e99ea1-0e63-44c6-b62e-9c62f3873c1c',
          linkedSurveyResultId: 'f90af0e1-2eb6-400e-961a-3376232fad90',
          title: 'survey.mercer.q3-answer-c-title',
          description: 'survey.mercer.q3-answer-c-sub-title'
        },
        {
          id: '140923fd-7433-483a-84d6-9918edb1c746',
          linkedSurveyResultId: '2c6121ef-d62a-4316-96fe-b3504a7fec18',
          title: 'survey.mercer.q3-answer-d-title',
          description: 'survey.mercer.q3-answer-d-sub-title'
        }
      ]
    },
    {
      id: 'd5859ca2-d0de-4310-a808-1062173a05c9',
      title: 'survey.mercer.q4-question',
      treeLevel: 2,
      answers: [
        {
          id: 'e6c9f61b-6c9c-46c7-9e0b-f58154b3c336',
          linkedSurveyResultId: '75aa52e6-61f3-4e81-bdbe-0dd473449221',
          title: 'survey.mercer.q4-answer-a-title'
        },
        {
          id: '90fd4cc1-6303-48d3-b388-e4fea7e6e217',
          linkedSurveyResultId: 'b8dbac74-84a1-4de9-af16-90bb8c13c031',
          title: 'survey.mercer.q4-answer-b-title'
        }
      ]
    },
    {
      id: '3c810f4c-b8cc-4424-af2e-53aac85e827a',
      title: 'survey.mercer.q5-question',
      treeLevel: 1,
      answers: [
        {
          id: '7fd101d0-c0dc-41c3-89c2-37099464b456',
          linkedSurveyResultId: '50d0e2bc-55ff-46ec-80f2-1b0b53df3d21',
          title: 'survey.mercer.q5-answer-a-title',
          description: 'survey.mercer.q5-answer-a-sub-title'
        },
        {
          id: '8f4f3e61-6a99-4ae6-a2d7-9b3680f8ec2a',
          linkedSurveyQuestionId: '1b47796b-718f-4896-b49f-dc9a75ffb95b',
          title: 'survey.mercer.q5-answer-b-title',
          description: 'survey.mercer.q5-answer-b-sub-title'
        },
        {
          id: '86681e66-d59d-4782-9ff2-810675d5b751',
          linkedSurveyQuestionId: 'b8a3c385-7a93-435b-889d-19ac5328cf00',
          title: 'survey.mercer.q5-answer-c-title',
          description: 'survey.mercer.q5-answer-c-sub-title'
        }
      ]
    },
    {
      id: '1b47796b-718f-4896-b49f-dc9a75ffb95b',
      title: 'survey.mercer.q6-question',
      treeLevel: 2,
      answers: [
        {
          id: '8052ae4b-72a1-4e5b-b95a-a05eb57e68d3',
          linkedSurveyResultId: 'd2ca02df-13a1-433e-a583-671a20dde078',
          title: 'survey.mercer.q6-answer-a-title'
        },
        {
          id: '2e6cacda-8710-491a-bad1-3e396d117e00',
          linkedSurveyResultId: 'c18343b9-644b-4f84-8e9c-820d55b97ef7',
          title: 'survey.mercer.q6-answer-b-title'
        }
      ]
    },
    {
      id: 'b8a3c385-7a93-435b-889d-19ac5328cf00',
      title: 'survey.mercer.q7-question',
      treeLevel: 2,
      answers: [
        {
          id: '8f8f49f4-c0fa-4dd3-b003-eb2b59569a7a',
          linkedSurveyResultId: 'aef47986-f8c4-4b05-ac3c-330d66ceca25',
          title: 'survey.mercer.q7-answer-a-title',
          description: 'survey.mercer.q7-answer-a-sub-title'
        },
        {
          id: 'f20c2ee5-e8f4-4589-967c-b5fae253059e',
          linkedSurveyResultId: 'cee98cc6-5b7c-4d4d-9411-06f4366179f0',
          title: 'survey.mercer.q7-answer-b-title',
          description: 'survey.mercer.q7-answer-b-sub-title'
        },
        {
          id: '1490175e-0e14-44a9-adb7-716906044c71',
          linkedSurveyResultId: 'd151ce0d-9a19-4e9a-b2e9-9bb15f5063dc',
          title: 'survey.mercer.q7-answer-c-title',
          description: 'survey.mercer.q7-answer-c-sub-title'
        }
      ]
    },
    {
      id: 'd251eb4a-6684-4cb5-95e2-b7e0aeffd16d',
      title: 'survey.mercer.q8-question',
      treeLevel: 1,
      answers: [
        {
          id: 'af41ebd0-ac89-4416-8bdb-4354d569d913',
          linkedSurveyQuestionId: '566a8715-e79f-4142-bf77-27877da78e63',
          title: 'survey.mercer.q8-answer-a-title'
        },
        {
          id: '1a0fdb6c-7c0e-4f23-a6ac-f70b215763e6',
          linkedSurveyResultId: 'b8084c2e-f24a-4550-af56-da62652b604b',
          title: 'survey.mercer.q8-answer-b-title'
        }
      ]
    },
    {
      id: '566a8715-e79f-4142-bf77-27877da78e63',
      title: 'survey.mercer.q9-question',
      treeLevel: 2,
      answers: [
        {
          id: '65c0e226-c5df-424e-a657-c6f9e8cdb13e',
          linkedSurveyResultId: 'fcc1dc8e-4ae6-4cec-baa6-a5e82fd0592b',
          title: 'survey.mercer.q9-answer-a-title'
        },
        {
          id: 'f29ec43f-fe33-4f54-b301-01b60cb62854',
          linkedSurveyQuestionId: '807d5a1a-28eb-46a1-9b1c-b47ef84581aa',
          title: 'survey.mercer.q9-answer-b-title'
        }
      ]
    },
    {
      id: '807d5a1a-28eb-46a1-9b1c-b47ef84581aa',
      title: 'survey.mercer.q10-question',
      treeLevel: 3,
      answers: [
        {
          id: 'eae6a82d-49c9-49c5-9da9-1228d6dae178',
          linkedSurveyResultId: 'a65276ef-fd47-48cc-be27-346f96f9fab8',
          title: 'survey.mercer.q10-answer-a-title'
        },
        {
          id: '15a7e3d5-5f64-4fe8-818d-b1d336eb9d2b',
          linkedSurveyResultId: '8c2bd2be-3c23-4462-90c4-d96e01162553',
          title: 'survey.mercer.q10-answer-b-title'
        }
      ]
    }
  ],
  results: [
    {
      id: '6d5a9229-0dcf-4b61-8de2-fbc0b1d16dbe',
      careerStream: MercerCareerStream.Executive,
      careerLevelShort: 'ET1'
    },
    {
      id: 'e7e26f54-d5d2-4e63-96bf-46ea24bfa8e1',
      careerStream: MercerCareerStream.Executive,
      careerLevelShort: 'ET2'
    },
    {
      id: '522b3c4f-b312-47b9-b573-340521ddb34f',
      careerStream: MercerCareerStream.Executive,
      careerLevelShort: 'ET3'
    },
    {
      id: '83716edc-1b99-438f-99ec-abf3fee241b3',
      careerStream: MercerCareerStream.Executive,
      careerLevelShort: 'E2'
    },
    {
      id: 'adb8822b-5f3e-4156-aa85-f45e066298b1',
      careerStream: MercerCareerStream.Executive,
      careerLevelShort: 'E1'
    },
    {
      id: '77aa62e6-61f3-4e81-bdbe-0dd222449221',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M6'
    },
    {
      id: '75aa52e6-61f3-4e81-bdbe-0dd473449221',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M5'
    },
    {
      id: 'b8dbac74-84a1-4de9-af16-90bb8c13c031',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M4'
    },
    {
      id: '602ced90-2f74-493c-af4f-f99e2323ec2b',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M3'
    },
    {
      id: 'f90af0e1-2eb6-400e-961a-3376232fad90',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M2'
    },
    {
      id: '2c6121ef-d62a-4316-96fe-b3504a7fec18',
      careerStream: MercerCareerStream.Management,
      careerLevelShort: 'M1'
    },
    {
      id: 'd151ce0d-9a19-4e9a-b2e9-9bb15f5063dc',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P6'
    },
    {
      id: 'cee98cc6-5b7c-4d4d-9411-06f4366179f0',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P5'
    },
    {
      id: 'aef47986-f8c4-4b05-ac3c-330d66ceca25',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P4'
    },
    {
      id: 'd2ca02df-13a1-433e-a583-671a20dde078',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P3'
    },
    {
      id: 'c18343b9-644b-4f84-8e9c-820d55b97ef7',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P2'
    },
    {
      id: '50d0e2bc-55ff-46ec-80f2-1b0b53df3d21',
      careerStream: MercerCareerStream.Professional,
      careerLevelShort: 'P1'
    },
    {
      id: 'fcc1dc8e-4ae6-4cec-baa6-a5e82fd0592b',
      careerStream: MercerCareerStream.ParaProfessional,
      careerLevelShort: 'S4'
    },
    {
      id: '8c2bd2be-3c23-4462-90c4-d96e01162553',
      careerStream: MercerCareerStream.ParaProfessional,
      careerLevelShort: 'S3'
    },
    {
      id: 'a65276ef-fd47-48cc-be27-346f96f9fab8',
      careerStream: MercerCareerStream.ParaProfessional,
      careerLevelShort: 'S2'
    },
    {
      id: 'b8084c2e-f24a-4550-af56-da62652b604b',
      careerStream: MercerCareerStream.ParaProfessional,
      careerLevelShort: 'S1'
    }
  ]
};
